import isNil from 'lodash/isNil';

export default class Formatter {
  private static numberFormatter = new Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD',
  });

  public static fromCurrency(value: string | number | null): string | number | null {
    if (isNil(value)) return null;
    return parseFloat(value.toString().replace('$', '').replace(/,/g, ''));
  }

  public static toCurrency(value: number | null): string | null {
    if (isNil(value)) return null;
    return this.numberFormatter.format(value);
  }

  public static fromString(value: string | number | null): number {
    if (!value) return 0;
    return parseFloat(value.toString());
  }
}
